import {useEffect, useState} from "react";
import EventListItem from "./ListItem";
import ChunkInfiniteScroll from "../InfiniteScroll/ChunkInfiniteScroll";
import {useTranslation} from "react-i18next";

const initialEventsListData = {
    events: [],
    currentPage: 1,
    loadingData: false,
    cancelLoading: false,
};

export default function FavoriteEventList({filters, chunkSize}) {
    const [eventsList, setEventsList] = useState(initialEventsListData)
    const { t } = useTranslation();

    useEffect(() => {
        if (eventsList.loadingData) {
            return;
        }
        setEventsList({...eventsList, loadingData: true});
        const url = `/api/v1/spa/conferences/favorite/${eventsList.currentPage}?`;
        fetch(url + new URLSearchParams({
            ...filters,
            startDate: filters.startDate ? filters.startDate.toDateString() : '',
            endDate: filters.endDate ? filters.endDate.toDateString(): '',
        }))
            .then(res => res.json())
            .then(
                (result) => {
                    const newState = eventsList.currentPage === 1 ? [] : eventsList.events;
                    newState.push(...result.events);
                    setEventsList({...eventsList, events: newState, loadingData: false, cancelLoading: result.events.length < chunkSize});
                }
            )
    }, [eventsList.currentPage, filters])
    const incrementPage = () => {
        setEventsList({...eventsList, currentPage: eventsList.currentPage + 1});
    };

    if (eventsList.cancelLoading && eventsList.events.length === 0) {
        return (
            <h2 className="not-found-title js-filters-failed" dangerouslySetInnerHTML={{__html: t('conferences.noConferences') }} />
        )
    }

    return (
        <div className="conferences-list-grid"
             data-extras-id="conference-list--on-the-list--370-370">
            <ChunkInfiniteScroll
                Component={EventListItem}
                items={eventsList.events}
                callback={incrementPage}
                cancel={eventsList.cancelLoading || eventsList.loadingData}
            />
        </div>
    )
}
